'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

FleetInsightConfig=function(){_createClass(FleetInsightConfig,null,[{key:'$inject',get:function()
{return['$stateProvider','$urlMatcherFactoryProvider']}}]);

function FleetInsightConfig($stateProvider,$urlMatcherFactoryProvider){_classCallCheck(this,FleetInsightConfig);
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('fleetInsight',{
url:'/fleetInsight?interval&groupId&{fleetInsightMainTabSelection:int}&{fatigueTrendsTabSelection:int}',
reloadOnSearch:!1});

$stateProvider.state(feature.fullName,feature.config);
}return FleetInsightConfig}();


module.exports=FleetInsightConfig;
//# sourceMappingURL=fleetInsightConfig.js.map
